import { palette } from "lib/miolo";
import IconCard, { CardDescription, CardValue } from "components/company/v2/cards/IconCard";
import lightFormat from "date-fns/lightFormat";
import type { IBrazilianCompanyIssuerTopLevelFragment } from "lib/fragments/__generated__/BrazilianCompanyIssuerTopLevel.generated";
import parseDateYmd from "lib/utils/parseDateYmd";
import numeral from "numeral";
import type { IAmericanCompanyIssuerTopLevelFragment } from "lib/fragments/__generated__/AmericanCompanyIssuerTopLevel.generated";
import CircleDollarSign from "components/svg/CircleDollarSign";
import type { IBrazilianRealEstateFundTopLevelFragment } from "lib/fragments/__generated__/BrazilianRealEstateFundTopLevel.generated";

interface IMarketCapCardProps {
  issuer:
    | IBrazilianCompanyIssuerTopLevelFragment
    | IBrazilianRealEstateFundTopLevelFragment
    | IAmericanCompanyIssuerTopLevelFragment;
}

export default function MarketCapCard({ issuer }: IMarketCapCardProps) {
  if (!issuer.marketCapitalization || issuer.marketCapitalization.totalCapitalization === 0) {
    return null;
  }

  const isAmericanIssuer = issuer.__typename === "AmericanCompanyIssuer";

  return (
    <IconCard primaryColor={palette.mariner} secondaryColor={palette.selago} icon={<CircleDollarSign />}>
      <CardValue title={numeral(issuer.marketCapitalization.totalCapitalization).format("0,0")}>
        {isAmericanIssuer ? "$" : "R$"}
        {numeral(issuer.marketCapitalization.totalCapitalization).format("0.0a").replace(".0", "").toUpperCase()}
      </CardValue>
      <CardDescription>
        Market Cap • {lightFormat(parseDateYmd(issuer.marketCapitalization.asOfDate), "dd/MM/yyyy")}
      </CardDescription>
    </IconCard>
  );
}
